module.exports = __webpack_public_path__ + "img/星链也能散发星光.00b12f7d.png";